import type { PoolAveragesResponse } from './types';

export async function fetchPoolAverages(poolAddress: string): Promise<PoolAveragesResponse> {
  const response = await fetch(`/api/pool/${poolAddress}/averages`);
  
  if (!response.ok) {
    throw new Error(`Failed to fetch pool averages: ${response.status} ${response.statusText}`);
  }
  
  return response.json();
}

export async function fetchAllPoolAverages(poolAddresses: string[]): Promise<Record<string, PoolAveragesResponse>> {
  const results = await Promise.allSettled(
    poolAddresses.map(async (address) => {
      const averages = await fetchPoolAverages(address);
      return { address, averages };
    })
  );

  const averagesMap: Record<string, PoolAveragesResponse> = {};
  
  results.forEach((result, index) => {
    if (result.status === 'fulfilled') {
      averagesMap[result.value.address] = result.value.averages;
    } else {
      console.error(`Failed to fetch averages for pool ${poolAddresses[index]}:`, result.reason);
    }
  });

  return averagesMap;
}
